import moment from 'moment';

export function MultiPlayCommissionPolicyArchiveService() {
    'ngInject';
    const service = {
        filterProductLine: filterProductLine,
        addProductLine: addProductLine,
        deleteProductLine: deleteProductLine,
        updateMultiPlayCommissionPolicyProductLine: updateMultiPlayCommissionPolicyProductLine
    };

    return service;

    function filterProductLine(productLine) {
        return !productLine.IsDeleted;
    }

    function addProductLine(productCommissionPolicy) {
        const productLine = {
            MultiPlayCommissionProductLineID: 0,
            MultiPlayCommissionID: productCommissionPolicy.MultiPlayCommissionID,
            ProductLineID: 0,
            IsNew: true,
            IsDeleted: false
        };
        productCommissionPolicy.MultiPlayCommissionPolicyProductLines.unshift(productLine);
        return productLine;
    }

    function deleteProductLine(productLine, productCommissionPolicy, confirmationFn) {
        confirmationFn = confirmationFn || (() => true);

        if (productLine.IsDeleted || !productLine.IsNew && !confirmationFn()) {
            productLine.IsDeleted = false;
            return;
        }

        productLine.IsDeleted = true;
    }

    function updateMultiPlayCommissionPolicyProductLine(productCommissionPolicy, productLine) {
        const affectedProductLines = [];
        const productLines = productCommissionPolicy.MultiPlayCommissionPolicyProductLines.filter(productLine => {
            return !productLine.IsDeleted;
        });
        const nextProductLine = productLines.reduce(function (nextProductLine, other) {
            // Completely ignore productLines that are before the updated one.
            if (other === productLine || moment(other.ActiveStart).isSameOrBefore(productLine.ActiveStart)) {
                return nextProductLine
            }

            if (!nextProductLine || moment(nextProductLine.ActiveStart).isSameOrAfter(other.ActiveStart)) {
                return other;
            } else {
                return nextProductLine;
            }
        }, null);

        if (nextProductLine && !productLine.ActiveEnd) {
            // Current productLine cannot have a null end date, so set it to the day before the next active start.
            productLine.ActiveEnd = moment(nextProductLine.ActiveStart).subtract(1, "day").toDate();
            affectedProductLines.push(productLine);
        }

        const previousProductLine = productLines.reduce(function (previousProductLine, other) {
            // Completely ignore productLines that are after the updated one.
            if (other === productLine || moment(other.ActiveStart).isSameOrAfter(productLine.ActiveStart)) {
                return previousProductLine
            }

            if (!previousProductLine || moment(previousProductLine.ActiveStart).isSameOrBefore(other.ActiveStart)) {
                return other;
            } else {
                return previousProductLine;
            }
        }, null);

        if (previousProductLine && !previousProductLine.ActiveEnd) {
            // Set the end for the previous productLine.
            previousProductLine.ActiveEnd = moment(productLine.ActiveStart).subtract(1, "day").toDate();
            affectedProductLines.push(previousProductLine);
        }

        return affectedProductLines;

    }
}
